export const configureReqParams = (value, autocorrection) => ({
  Ntt: value,
  ...autocorrection ? { Ntk: 'SI_Global' } : {}
})
